export default __webpack_public_path__ + "static/media/mike.25b8caa5.png";